import { render, staticRenderFns } from "./NavegationButtons.vue?vue&type=template&id=de66a8ba"
import script from "./NavegationButtons.vue?vue&type=script&lang=js"
export * from "./NavegationButtons.vue?vue&type=script&lang=js"
import style0 from "./NavegationButtons.vue?vue&type=style&index=0&id=de66a8ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports